import React, { useState, useEffect } from 'react';
import { getTicketSummaryByCreator } from "../../api/ticketsApi";
import { useNotification } from "../../context/NotificationContext";

const MyTicketSummary = ({ handleSearch }) => {
  const [myticketSummary, setMyTicketSummary] = useState([]);
  const [assignedticketSummary, setAssignedTicketSummary] = useState([]);
  const [loading, setLoading] = useState(true);

  const notify = useNotification();

  // Fetch ticket summary data
  const fetchTicketSummary = async () => {
    try {
      setLoading(true);
      const response = await getTicketSummaryByCreator();
      if (response.status === 200) {
        const data = response.data;
        setMyTicketSummary(data.myList);
        setAssignedTicketSummary(data.assignedList);
      }
    } catch (error) {
      notify("error", "Failed to load ticket summary.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTicketSummary();
  }, []);

  // Render sections based on the name
  const renderSections = (sectionName, sectionData) => {
    const itemsPerSection = 6;
    const sections = [];
    for (let i = 0; i < sectionData.length; i += itemsPerSection) {
      sections.push(sectionData.slice(i, i + itemsPerSection));
    }
    return sections.map((chunk, idx) => {
      const gridCols = chunk.length === 0 ? 'grid-cols-1' : (chunk.length < 3 ? `grid-cols-${chunk.length}` : 'grid-cols-3');
      return (
        <section key={idx} className={`grid ${gridCols} gap-6 mb-6`}>
          <h2 className="col-span-full text-lg font-semibold text-gray-400" aria-label={`${sectionName} Summary`}>
            {sectionName}
          </h2>
          {chunk.map((item, idx) => (
            <div key={idx} className="bg-white shadow-lg p-6 rounded-lg flex justify-between items-center border border-blue-400">
              <div className="flex-grow text-left">
                <h3 className="text-gray-500 text-lg font-semibold">{item.name} Tickets</h3>
                <p className="text-4xl font-bold text-blue-500">
                  {loading ? "Loading..." : item.value}
                </p>
              </div>
              <div className="text-right">
                <p className="text-4xl font-bold text-blue-500">
                  {loading ? "Loading..." : `${item.key}`}
                </p>
              </div>
            </div>
          ))}
        </section>
      );
    });
  };

  const renderTicketSection = (ticketSummary, sectionName) => {
    const filteredSummary = ticketSummary.filter((section) => section.name === sectionName);
    const sectionLabel = sectionName === "ProgressStatus" ? "Progress Status" : sectionName;

    if (filteredSummary.length === 0) {
      return (
        <div className="text-center bg-gray-100 p-4 rounded-lg shadow-md">
          <p className="text-gray-500">No entry found for {sectionLabel}</p>
        </div>
      );
    }

    return filteredSummary.map((section, index) => (
      <React.Fragment key={index}>
        {renderSections(`By ${sectionLabel}`, section.object)}
      </React.Fragment>
    ));
  };

  const renderSummary = (ticketSummary, title) => {
    return (
      <section className="mb-6">
        <h4 className="col-span-full text-lg font-semibold text-gray-400 text-center mb-4">{title}</h4>
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-spin h-6 w-6 border-t-2 border-b-2 border-blue-500 rounded-full"></div>
            <span className="ml-2 text-blue-500">Loading...</span>
          </div>
        ) : (
          <>
            {renderTicketSection(ticketSummary, "Priority")}
            {renderTicketSection(ticketSummary, "ProgressStatus")}
          </>
        )}
      </section>
    );
  };

  return (
    <div className="p-6 space-y-8">
      {myticketSummary.length === 0 ? (
        <p className="text-center text-gray-500">Not available.</p>
      ) : (
        renderSummary(myticketSummary, "My Tickets")
      )}

      {assignedticketSummary.length === 0 ? (
        <p className="text-center text-gray-500">Not available.</p>
      ) : (
        renderSummary(assignedticketSummary, "Assigned Tickets")
      )}
    </div>
  );
};

export default MyTicketSummary;
